import { Component, Input, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import { Table, TableFilterEvent, TableModule } from "primeng/table";
import { OrdersListingService } from "../../../../core/services/orders-listing.service";
import { OrderListingPaginatedService } from "../../../../core/services/order-listing-paginated.service";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { GetProjectInvoiceProposalsList } from "../../../../core/models/orders/getInvoicebySalesOrderIdResponseDto.dto";
import { ProjectInvoiceReportSalesInvoiceList } from "../../../../core/models/orders/getProjectInvoiceReportSalesResponseDto";
import { GetSaleOrdersDto } from "../../../../core/models/orders/getSaleOrdersDto";
import { SharedService } from "../../../../core/services/shared.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { CommonModule, DatePipe } from "@angular/common";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../order-summary/order-summary.component";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { BooleanToStringPipe } from "../../../../shared/pipes/booleanToString/booleanToString.pipe";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { InvoicePreviewListDailogComponent } from "../invoice-preview-list-dailog/invoice-preview-list-dailog.component";
import { InvoicePdfDialogueComponent } from "../invoice-pdf-dialogue/invoice-pdf-dialogue.component";
import { DateFilter } from "../../../../core/models/shared/dateFilter";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { RadioButtonModule } from "primeng/radiobutton";
import { SelectModule } from "primeng/select";
import { CardModule } from "primeng/card";
import { ButtonModule } from "primeng/button";
import { SidebarService } from "../../../../core/services/sidebar.service";
import { DialogModule } from "primeng/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatePickerModule } from "primeng/datepicker";

@UntilDestroy()
@Component({
  selector: "jni-orders-listing",
  templateUrl: "./orders-listing.component.html",
  styleUrls: ["./orders-listing.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    InvoicePdfDialogueComponent,
    InvoicePreviewListDailogComponent,
    DialogModule,
    FormsModule,
    SelectModule,
    DatePickerModule,
    BooleanToStringPipe,
    HidedynamicsdatePipe,
    DateFilterComponent,
    RadioButtonModule,
    CardModule,
    ButtonModule,
    SpinnerComponent,
    ClientDetailsComponent,
    ReactiveFormsModule,
  ],
})
export class OrdersListingComponent implements OnInit {
  saleordersListing: GetSaleOrdersDto[] = [];
  filterSaleordersListing: GetSaleOrdersDto[] = [];
  selectedorderListing: GetSaleOrdersDto[] = [];
  listAfterGridFilter: GetSaleOrdersDto[] = [];
  //ordersfilterList: any[] = [];
  showSmallLoader = false;
  checkboxStatus = 0;
  currentPagination = 20;
  orderDisplayModal = false;
  clientDisplayModal = false;
  saleOrderId = "";
  customerId = "";
  @ViewChild("dt") table!: Table;
  selectedRadioButton = "All";
  invoicePdfDialogue = false;
  invoiceList: ProjectInvoiceReportSalesInvoiceList[] = [];
  selectedMatchMode = "between";
  startDate = "";
  endDate = "";
  showFilterDialog = false;

  matchModeOptions = [
    { label: "Between", value: "between" },
    { label: "Date is", value: "dateIs" },
    { label: "Date before", value: "dateBefore" },
    { label: "Date after", value: "dateAfter" },
  ];
  isError = false;
  errorLabel = "";

  @Input() isAdditionalFilters = "";
  @Input() orderType = "";
  searchPlaceholder = "Search";
  descriptionCharacterCond = false;
  custPoCharacterCount = false;

  inHandDateColumn = "inHandsDateD365";
  createdDateColumn = "createdDate";
  invoiceReviewSummaryDisplayModal = false;
  IrSalesOrderId = "";
  IrprojId = "";
  popupSmallLoader = false;
  projectInvoicesProposalList = [] as GetProjectInvoiceProposalsList[];
  displayProjectInvoiceProposal = false;
  userRole = 0;
  enumUserRole = UserRole;

  @Input() customerAccountNumber = "";

  constructor(
    private _router: Router,
    private _toastr: JniToastrService,
    private _ordersListingService: OrdersListingService,
    private renderer: Renderer2,
    private _activatedRoute: ActivatedRoute,
    protected _sharedService: SharedService,
    private _orderListingPaginatedService: OrderListingPaginatedService,
    private _loginService: UserManagementService,
    private _sidebarService: SidebarService,
    private _dataPipe: DatePipe
  ) {
    this.closeModalOnSaleOrder();
    this._activatedRoute.params.subscribe(params => {
      this.isAdditionalFilters = params["isAdditionalFilters"]
        ? params["isAdditionalFilters"]
        : this.isAdditionalFilters;
    });
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.getAllSaleOrder();
    this.closeModalOnSaleOrder();

    if (this.isAdditionalFilters != "1") {
      this._sharedService.clearDashbaordPocAdditionalFiltersObject();
    }

    this._sharedService.searchTextValueBehaviorSubject.subscribe(x => {
      // this.searchedText = x;
      if (x) {
        this.searchPlaceholder = `Results for "${x}"`;
      }
    });
  }

  closeModalOnSaleOrder() {
    if (this._sidebarService.menu$() === "orders") {
      this.orderDisplayModal = false;
      this.clientDisplayModal = false;
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }
  }

  getAllSaleOrder() {
    this.showSmallLoader = true;
    const obj = this._sharedService.getDashbaordPocAdditionalFiltersObject();
    const objSimpleOrderSearch =
      this._sharedService.getSimpleOrderSearchResponseObject();
    const searchedText = this._sharedService.getOrderSearchValue();
    const request: DashbaordPocAdditionalFilters = {
      skip: 0,
      take: 0,
      filters: [],
      sort: [{ field: "createdDate", order: 1 }],
      additionalFilters: obj.additionalFilters,
      bacNumber: obj.bacNumber,
      brandingConsultant: obj.brandingConsultant,
      status: obj.status,
      fromDate: obj?.fromDate
        ? `${this._dataPipe.transform(obj.fromDate, "yyyy-MM-dd")}T00:00:00.000Z`
        : `${this._dataPipe.transform(new Date(), "yyyy-MM-dd")}T00:00:00.000Z`,
      toDate: obj?.toDate
        ? `${this._dataPipe.transform(obj.toDate, "yyyy-MM-dd")}T23:59:59.999Z`
        : `${this._dataPipe.transform(new Date(), "yyyy-MM-dd")}T00:00:00.000Z`,
      customerAccountNumber: obj.customerAccountNumber,
      isSimpleOrderSearch:
        searchedText?.length || obj.dashboardSalesOrderId?.length
          ? true
          : false,
      simpleSearchSaleOrderIds: objSimpleOrderSearch?.length
        ? objSimpleOrderSearch
        : obj.dashboardSalesOrderId,
      orderCreatedDateFilterCriteria: "",
      applyNonAdminRules: obj.applyNonAdminRules,
      brandingConsultantNumber: obj.brandingConsultantNumber,
      isInventorySales: this.orderType == "inventory-sales",
    };

    if (this.customerAccountNumber) {
      request.customerAccountNumber = this.customerAccountNumber;
      request.additionalFilters = true;
    }

    // this.clearAndSetSimpleOrderSearchResponseObj();
    // this._sharedService.setOrderSearchValue('');
    this._ordersListingService
      .getAllSaleOrders(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.saleordersListing = res.data;
          this.filterSaleordersListing = this.saleordersListing;
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message ?? "Data not found");
        },
      });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  onOrdersRedirection() {
    let state = {} as NavigationExtras;
    state = {
      state: {
        orderType: this.orderType,
      },
    } as NavigationExtras;
    this._router.navigate(["orders/order-header"], state);
  }

  exportExcel() {
    this.showSmallLoader = true;
    this.exportExcelForFilterData(this.listAfterGridFilter);
    this.showSmallLoader = false;
    // if (this.selectedorderListing.length > 0) {
    //   this.exportExcelForFilterData(this.selectedorderListing);
    //   this.showSmallLoader = false;
    // } else {
    //   if (this.listAfterGridFilter && this.listAfterGridFilter.length) {
    //     this.exportExcelForFilterData(this.listAfterGridFilter);
    //   } else {
    //     this.exportExcelForFilterData(this.saleordersListing);
    //   }
    //   this.showSmallLoader = false;
    // }
  }

  // onDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.saleordersListing.filter((x) =>
  //       x.inHandsDateD365?.includes(event.target.value)
  //     );
  //     this.filterSaleordersListing = filterList;
  //   } else {
  //     this.filterSaleordersListing = this.saleordersListing;
  //   }
  // }

  exportExcelForFilterData(filterclientlist: GetSaleOrdersDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Order #"]: datum.salesOrderIdD365,
        ["Pct"]: datum.orderPercentCompleteD365,
        ["Status"]: datum.salesOrderStatusD365,
        ["Paid Status"]: datum.prepayD365,
        ["Client Name"]: datum.customerName,
        ["Job Name"]: datum.jobNameD365,
        ["Buyer"]: datum.buyerD365,
        ["In hands"]: new Date(datum.inHandsDateD365 ?? ""),
        ["Created"]: new Date(datum.createdDate),
        ["Subtotal"]: datum.orderSubTotal,
        ["PrePay"]: datum.clientDepositD365,
        ["Commission"]: datum.commissionD365,
        ["Gp%"]: datum.grossProfitPercentageD365 ?? 0,
        ["Currency"]: datum.foreignCurrencyD365,
        ["Cust PO"]: datum.customerPONumberD365,
        ["BC"]: datum.brandingConsultant,
        ["Prime Support"]: datum.accountsCoordinatorNameD365,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrderList");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  redirectToSummary(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
    // this._router.navigate(['orders/order-summary/' + saleOrderId]);
  }

  redirectToClientSummary(customerId: string) {
    if (customerId) {
      this.customerId = customerId;
      this.clientDisplayModal = true;
    }
    // this._router.navigate(['orders/order-summary/' + saleOrderId]);
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeClientModal() {
    this.clientDisplayModal = false;
  }

  getInfinity(percentage: number) {
    if (Number.isFinite(percentage)) {
      return true;
    } else {
      return false;
    }
  }

  onFilter(event: TableFilterEvent, dt: Table) {
    this.currentPagination = dt._rows ?? 0;
    if (event.filteredValue && Object.keys(event.filteredValue).length !== 0) {
      this.listAfterGridFilter = event.filteredValue;
    } else {
      this.listAfterGridFilter = [];
    }
  }

  lastPageStatus = true;
  setMyPagination(dt: Table) {
    this.currentPagination = dt._rows ?? 0;
    const pageDiff = dt._totalRecords - (dt._first ?? 0);
    if (pageDiff <= (dt._rows ?? 0)) {
      this.lastPageStatus = false;
    } else this.lastPageStatus = true;
  }

  getOrderOnChange(value: string) {
    if (value == "Openorder") {
      this.selectedRadioButton = "Open order";
    } else {
      this.selectedRadioButton = value;
    }

    if (this.selectedRadioButton.toLowerCase() != "all") {
      this.filterSaleordersListing = this.saleordersListing.filter(
        x =>
          x.salesOrderStatusD365?.toLowerCase() ==
          this.selectedRadioButton.toLowerCase()
      );
    } else {
      this.filterSaleordersListing = this.saleordersListing;
    }
  }

  onStatusClick(salesOrderId: string) {
    if (salesOrderId) {
      this.showSmallLoader = true;
      this._orderListingPaginatedService
        .getProjectInvoiceReportSales({
          SalesOrderId: salesOrderId,
        })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.status?.toLowerCase() == "success") {
              if (res.data) {
                if (res.data.InvoiceCount == 1) {
                  this.showSmallLoader = true;
                  this._orderListingPaginatedService
                    .getProjectInvoiceReport({
                      InvoiceDate: res.data.InvoiceList[0]?.InvoiceDate ?? "",
                      ProjectInvoiceId:
                        res.data.InvoiceList[0]?.ProjectInvoiceId,
                    })
                    .pipe(untilDestroyed(this))
                    .subscribe({
                      next: res => {
                        this.showSmallLoader = false;
                        if (res.data?.reportBase64String) {
                          const blob = this.b64toBlob(
                            res.data.reportBase64String,
                            "application/pdf"
                          );
                          const blobUrl = URL.createObjectURL(blob);
                          window.open(blobUrl);
                        } else {
                          this._toastr.error(
                            "Error",
                            res.message || "Failed To Fetch Invoice PDF"
                          );
                        }
                      },
                      error: () => {
                        this.showSmallLoader = false;
                        this._toastr.error(
                          "Error",
                          "Failed To Fetch Invoice PDF"
                        );
                      },
                    });
                } else if (res.data.InvoiceCount > 1) {
                  this.showSmallLoader = false;
                  this.invoiceList = res.data.InvoiceList;
                  this.invoicePdfDialogue = true;
                } else {
                  this.showSmallLoader = false;
                  this._toastr.error(
                    "Error",
                    res.message ?? "Failed To Fetch Invoice PDF"
                  );
                }
              } else {
                this.showSmallLoader = false;
                this._toastr.error(
                  "Error",
                  res.message ?? "Failed To Fetch Invoice PDF"
                );
              }
            } else {
              this.showSmallLoader = false;
              this._toastr.error(
                "Error",
                res.message ?? "Failed To Fetch Invoice PDF"
              );
            }
          },
          error: () => {
            this.showSmallLoader = false;
            this._toastr.error("Error", "Failed To Fetch Invoice PDF");
          },
        });
    }
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  closeUrlDialog() {
    this.invoicePdfDialogue = false;
  }

  onClear() {
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
    this._router
      .navigateByUrl("orders/refresh-component", {
        skipLocationChange: true,
      })
      .then(() => {
        this._router.navigate(["orders"]);
      });
  }

  convertStringToDateExcludeTime(stringDate: string) {
    if (stringDate) {
      return new Date(stringDate).setHours(0, 0, 0, 0);
    } else return new Date();
  }

  // clearDateFilter(){
  //   this.rangeDates = [];
  //   this.filterSaleordersListing = this.saleordersListing;
  // }

  // checkCrossIcon(){
  //   if(this.rangeDates?.length > 0){
  //     return true;
  //   }
  //   else
  //   {
  //     return false;
  //   }
  // }

  // onOrderDateDateFilter() {
  //   if(this.rangeDates.length > 0){
  //     const startdate = this.rangeDates[0];
  //     const endDate = this.rangeDates[1] ?? null;
  //     if(startdate && endDate){
  //       const filterList = this.saleordersListing.filter((x) =>
  //           x.createdDate ? this.convertStringToDateExcludeTime(x.createdDate) >= startdate &&
  //            this.convertStringToDateExcludeTime(x.createdDate) <= endDate
  //           : null
  //         );
  //       this.filterSaleordersListing = filterList;
  //     }
  //     else if(startdate){
  //       const filterList = this.saleordersListing.filter((x) =>
  //       x.createdDate ? this.convertStringToDateExcludeTime(x.createdDate) >= startdate
  //       : null
  //     );
  //     this.filterSaleordersListing = filterList;
  //     }

  //   }
  // }

  clearFilter($event: GetSaleOrdersDto[] | DateFilter) {
    if (Array.isArray($event)) {
      this.filterSaleordersListing = $event;
    }
  }

  applyFilter($event: GetSaleOrdersDto[] | DateFilter) {
    if (Array.isArray($event)) {
      this.filterSaleordersListing = $event;
    }
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 30) this.descriptionCharacterCond = true;
    }
  }

  custPoCharacterCountMethod(obj: string) {
    if (obj) {
      if (obj.length > 15) this.custPoCharacterCount = true;
    }
  }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  redirectToIRSummary(saleOrderId: string, projId: string) {
    if (saleOrderId && projId) {
      const url = `invoice-review/invoice-review-summary/${saleOrderId}/${projId}`;
      window.open(url);
    }
  }

  getProjectInvoiceProposalsBySalesOrderId(salesOrderId: string) {
    this.popupSmallLoader = true;
    this.displayProjectInvoiceProposal = true;
    this._orderListingPaginatedService
      .getProjectInvoiceProposalsBySalesOrderId(salesOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.popupSmallLoader = false;
          if (res.data && res.status.toLowerCase() === "success") {
            if (res.data?.Proposals) {
              this.projectInvoicesProposalList = res.data.Proposals;
            }
          } else {
            this._toastr.error("Error", res.message);
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to fetch invoices from D365");
          this.popupSmallLoader = false;
        },
      });
  }

  closeProjectInvoiceProposalEvent() {
    this.displayProjectInvoiceProposal = false;
    this.projectInvoicesProposalList = [] as GetProjectInvoiceProposalsList[];
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
      });
  }
}
